const initialState = { decorations: [], decoration: {}, count: 0 };

export default function decorations(state = initialState, action) {
  switch (action.type) {
    case 'GET_DECORATIONS':
      return { ...state, decorations: action.decorations, count: action.count };
    case 'ADD_DECORATION':
      return { ...state, decorations: [action.payload, ...state.decorations] };
    case 'DELETE_DECORATION':
      return { ...state, decorations: state.decorations.filter((decoration) => decoration.objectId !== action.id) };
    case 'EDIT_DECORATION':
      return { ...state, decoration: action.decoration };
    case 'UPDATE_DECORATION':
      return {
        ...state,
        decorations: state.decorations.map((decoration) => (decoration.objectId === action.decoration.objectId ? action.decoration : decoration)),
        decoration: action.decoration,
      };
    case 'REORDER_DECORATIONS':
      return { ...state, decorations: action.decorations };
    default:
      return state;
  }
}
